var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteEmployee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9338_27715)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.17969 8.18942C8.37212 8.8055 8.71043 9.36603 9.16587 9.82339C9.62131 10.2807 10.1804 10.6214 10.7957 10.8164M14.3027 10.2714C14.7799 9.93473 15.1777 9.49762 15.4679 8.99079C15.7582 8.48396 15.9339 7.91973 15.9828 7.33772C16.0317 6.75572 15.9525 6.17007 15.7509 5.62193C15.5492 5.07378 15.23 4.57645 14.8156 4.16487C14.4012 3.7533 13.9017 3.43746 13.3522 3.23956C12.8027 3.04165 12.2165 2.96649 11.6349 3.01934C11.0532 3.07219 10.4902 3.25178 9.98534 3.54549C9.4805 3.83919 9.04611 4.23989 8.71269 4.71942",
    stroke: "#BD0E16",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 21V19C6 17.9391 6.42143 16.9217 7.17157 16.1716C7.92172 15.4214 8.93913 15 10 15H14C14.412 15 14.81 15.062 15.183 15.178M17.816 17.796C17.936 18.176 18 18.581 18 19V21",
    stroke: "#BD0E16",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3L21 21",
    stroke: "#BD0E16",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9338_27715"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteEmployee);
export default __webpack_public_path__ + "static/media/delete_employee.4e9ce569099007fe0d111b1d0d7a1a1c.svg";
export { ForwardRef as ReactComponent };